import $ from 'jquery';
import toastr from '../../../node_modules/toastr/build/toastr.min.js';
import { tl_format } from './constants';
import Swal from 'sweetalert2';

export default function () {
    basketProcess();
}

function basketProcess() {
    $(document).on('click', '.js-add-to-basket', function (e) {
        e.preventDefault();

        if($('.js-product-variant-wrapper').length && !$('.js-select-variant[data-variant-type=integration_size]').parent().hasClass('selected'))
        {
            Swal.fire('Uyarı', 'Lütfen beden seçimi yapın', 'warning');
            return false;
        }

        const productid = $(this).data('product-id');
        const pk = $(this).data('pk');
        const quantity = $('.js-qty-input').length ? parseInt($('.js-qty-input').val()) : 1;
        const data = {
            "process": "add",
            "quantity": quantity,
            "ProductID": productid,
            "pk": pk
        };

        if (productid) {
            $.ajax({
                url: window.GLOBALS.baseLink + 'basket-process',
                type: 'POST',
                data: data,
                dataType: 'json', 
                success: function (response) {
                    if (response) {
                        if (response.IsSuccess) {
                            toastr.success(response.Message, response.Title)
                            $('.js-basket-qty').text(response.TotalCount)
                            
                            if(response.AddedProducts)
                            {
                                $('.js-ps-cart__items').html('');
                                $('.js-basket-total-amount').html('');
                                $.each(response.AddedProducts, function(i, e) {
                                    const temp = `
                                    <div class="ps-product--cart-mobile">
                                        <div class="ps-product__thumbnail">
                                        <a href="${window.GLOBALS.baseLink}urun/${e.Slug}">
                                            <img src="${e.Image}" alt="${e.Title}" />
                                        </a>
                                        </div>
                                        <div class="ps-product__content">
                                        <a class="ps-product__remove js-remove-to-basket" href="#" data-product-id="${e.ProductID}">
                                            <i class="icon-cross"></i>
                                        </a>
                                        <a href="${window.GLOBALS.baseLink}urun/${e.Slug}">
                                        ${e.Title}
                                        </a>
                                        <small class="d-block">
                                            ${e.Count} x ${e.Price} TL
                                        </small>
                                        </div>
                                    </div>
                                    `;
                                    $('.js-ps-cart__items').append(temp)
                                });

                                $('.js-basket-total-amount').text(response.TotalPrice.toFixed(2)+ 'TL')
                                
                                // Added Modal
                                const $addedProductWrapper = $('#added-product-modal');
                                $('.js-added-product-item table').html('');
                                
                                $.each(response.AddedProducts, function(i, e) {
                                    window.closeWaitMe($addedProductWrapper);
                                    window.waitMe($('#product-quickview .modal-content'));

                                    let product = `
                                        <tr>
                                            <td width="100">
                                                <img src="${e.Image}" alt="${e.Title}" class="js-preview-modal-image w-100">
                                            </td>
                                            <td>
                                                ${e.Title}
                                            </td>
                                            <td>
                                                ${e.Count} Adet
                                            </td>
                                            <td>
                                                ${tl_format(e.Price)}
                                            </td>
                                        </tr>
                                    `;
                                    $('.js-added-product-item table').append(product);
                                    window.closeWaitMe($('#added-product-modal .modal-content'));
                                });
                                
                                
                                $('#added-product-modal').modal('show');

                            }
                        } else {
                            toastr.error(response.Message, response.Title)
                        }
                    }
                }
            })
        }
    });

    $(document).on('click', '.js-remove-to-basket', function (e) {
        e.preventDefault();

        const productid = $(this).data('product-id');
        const data = {
            "process": "remove",
            "ProductID": productid
        };

        if (productid) {
            $.ajax({
                url: window.GLOBALS.baseLink + 'basket-process',
                type: 'POST',
                data: data,
                dataType: 'json',
                success: function (response) {
                    if (response) {
                        if (response.IsSuccess) {
                            toastr.success(response.Message, response.Title)
                            setTimeout(function () {
                                window.location.reload();
                            }, 500)
                        } else {
                            toastr.error(response.Message, response.Title)
                        }
                    }
                }
            })
        }
    });

    $('.js-increase').on('click', function (e) {
        e.preventDefault();

        const productid = $(this).data('product-id');
        const quantity = $('.js-qty-input').length ? parseInt($('.js-qty-input').val()) : 1;
        const data = {
            "process": "increase",
            "quantity": quantity,
            "ProductID": productid
        };

        if (productid) {
            $.ajax({
                url: window.GLOBALS.baseLink + 'basket-process',
                type: 'POST',
                data: data,
                dataType: 'json',
                success: function (response) {
                    if (response) {
                        if (response.IsSuccess) {
                            toastr.success(response.Message, response.Title)
                            setTimeout(function () {
                                window.location.reload();
                            }, 500)
                        } else {
                            toastr.error(response.Message, response.Title)
                        }
                    }
                }
            })
        }
    })

    $('.js-decrease').on('click', function (e) {
        e.preventDefault();
        const qtyVal = $('.js-qty-input').val();
        const productid = $(this).data('product-id');
        const data = {
            "process": "decrease",
            "ProductID": productid
        };

        if (productid) {
            
            if (qtyVal < 1) {
                toastr.error("Ürün adedi 1'den az olamaz", 'Uyarı')
                return;
            }

            $.ajax({
                url: window.GLOBALS.baseLink + 'basket-process',
                type: 'POST',
                data: data,
                dataType: 'json',
                success: function (response) {
                    if (response) {
                        if (response.IsSuccess) {
                            toastr.success(response.Message, response.Title)
                            setTimeout(function () {
                                window.location.reload();
                            }, 500)
                        } else {
                            toastr.error(response.Message, response.Title)
                        }
                    }
                }
            })
        }
    })
}
